import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "@/store"
import { GameplaySelectors } from "@/store/slices/gameplay"
import { Spinner } from "@/ui/Spinner"
import styles from "./GameConnectionOverlay.module.scss"

export const GameConnectionOverlay: FC = () => {
  const { t } = useTranslation()
  const isVisible = useAppSelector(
    GameplaySelectors.selectIsConnectionOverlayVisible()
  )

  if (!isVisible) return null

  return (
    <div className={styles.GameConnectionOverlay_container}>
      <Spinner />
      <p className={styles.GameConnectionOverlay_text}>
        {t("gameConnection.reconnecting")}
      </p>
    </div>
  )
}
